import Client from "../client";
import { UserIdentityMetadataResource } from "client/authentication";
import UserAuthenticationResource from "client/resources/userAuthenticationResource";

class UserIdentityMetadataRepository  {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    all(): Promise<UserIdentityMetadataResource> {
        return this.client.get(this.client.getRootDocument().Links["UserIdentityMetadata"]);
    }
    authenticationConfiguration(userId: string) {
        return this.client.get<UserAuthenticationResource>(this.client.getRootDocument().Links["UserAuthentication"], {userId});
    }
}

export default UserIdentityMetadataRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/userIdentityMetadataRepository.ts